import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HardwareBuildupApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class HardwareBuildupApiModule {
    public static forRoot(configurationFactory: () => HardwareBuildupApiConfiguration): ModuleWithProviders<HardwareBuildupApiModule> {
        return {
            ngModule: HardwareBuildupApiModule,
            providers: [ { provide: HardwareBuildupApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: HardwareBuildupApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('HardwareBuildupApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
